import { render, staticRenderFns } from "./GeneralCompanyCreate.vue?vue&type=template&id=9389ca48&scoped=true&"
import script from "./GeneralCompanyCreate.vue?vue&type=script&lang=js&"
export * from "./GeneralCompanyCreate.vue?vue&type=script&lang=js&"
import style0 from "./GeneralCompanyCreate.vue?vue&type=style&index=0&id=9389ca48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9389ca48",
  null
  
)

export default component.exports